
// PLACES-CAPACITY-UNIFIED: collection lenses are Offices · Markets · Capacity.
// Pressure and Scenario are retired as collection lenses (their components
// stay in the codebase for rollback) but their governance rows still gate the
// market-record Pressure/Scenario tabs, so they remain resolvable here.
export const PLACES_LENSES = Object.freeze([
  { key: "places_offices", lens: "offices", label: "Offices" },
  { key: "places_markets", lens: "markets", label: "Markets" },
  { key: "places_capacity", lens: "capacity", label: "Capacity", description: "Capacity forecast, scenario panel and seat planning" },
]);

export const RETIRED_PLACES_LENSES = Object.freeze([
  { key: "places_pressure", lens: "pressure", label: "Pressure" },
  { key: "places_scenario", lens: "scenario", label: "Scenario" },
]);

export const DEFAULT_PLACES_TABS = [...PLACES_LENSES, ...RETIRED_PLACES_LENSES].map((row, sort_order) => ({
  ...row, enabled: true, sort_order,
}));

const rowEnabled = (tabs, key) => tabs.some((row) => row.key === key && row.enabled === true);

// The configuration migration preserves the old Pressure OR Scenario value.
// Runtime readers never fall back to record-tab flags: they cannot re-enable
// a disabled (or missing) collection flag.
export function capacityLensEnabled(tabs = DEFAULT_PLACES_TABS) {
  if (!Array.isArray(tabs)) return false;
  return rowEnabled(tabs, "places_capacity");
}

// An explicit empty collection is authoritative, not a request for defaults.
export function enabledPlacesLenses(tabs = DEFAULT_PLACES_TABS) {
  return PLACES_LENSES.filter((lens) => (lens.lens === "capacity"
    ? capacityLensEnabled(tabs)
    : rowEnabled(tabs, lens.key)));
}

export function resolvePlacesLens(lens, tabs) {
  const enabled = enabledPlacesLenses(tabs);
  // Record-tab governance still asks about the retired lenses directly.
  const retired = RETIRED_PLACES_LENSES.find((row) => row.lens === lens);
  if (retired && Array.isArray(tabs) && rowEnabled(tabs, retired.key)) return lens;
  return enabled.find((row) => row.lens === lens)?.lens ?? enabled[0]?.lens ?? null;
}

export function placesLensFromPath(pathname) {
  return /^\/places\/(offices|markets|capacity)\/?$/.exec(pathname)?.[1] ?? null;
}
